export const getFocusAreasHeaders = () => {
    const headers = [
        { id: 1, header_name: "Name", sort_column: "Name" },
        { id: 2, header_name: "Geometry", sort_column: "Geometry" },
        { id: 3, header_name: "Behavior", sort_column: "Behavior" }
    ];

    return headers;
};